import axios from "axios";
const endpoint = "/users/v1/auth";
class AuthService {
	async createUser(user) {
		const response = await axios.post(`${endpoint}/register`, user);
		const { data } = response;
		this.setSession(data.accessToken);
		return data;
	}

	async signInWithEmailAndPassword(login) {
		const response = await axios.post(`${endpoint}/customer`, login);
		const { data } = response;
		this.setSession(data.accessToken);
		return data;
	}

	setSession = (access_token) => {
		if (access_token) {
			sessionStorage.setItem("vino_access_token", access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			sessionStorage.removeItem("vino_access_token");
			delete axios.defaults.headers.common.Authorization;
		}
	};

	logout = () => {
		this.setSession(null);
	};

	isAuthTokenValid = (access_token) => {
		if (!access_token) {
			return false;
		}
		const decoded = jwtDecode(access_token);
		const currentTime = Date.now() / 1000;
		if (decoded.exp < currentTime) {
			console.warn("access token expired");
			return false;
		}

		return true;
	};

	getAccessToken = () => {
		return window.sessionStorage.getItem("vino_access_token");
	};
}

export default new AuthService();
